import { of } from "rxjs";
import { filter, switchMap, take } from "rxjs/operators";
import { selectIsTutorialActive } from "../../selectors/selectTutorial";
import { actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { TypeActionScene } from "../scenes/actionScenes";
import { IdScene } from "../scenes/types/IdScene";
import { TypeActionTutorial } from "../tutorial/actionTutorial";
export var epicOpenTerminationDialog = function (action$, state$) {
    return action$.pipe(filter(function (action) {
        var tutorialHappening = selectIsTutorialActive(state$.value);
        if (tutorialHappening) {
            return false;
        }
        var spawnFirstDialog = action.type === TypeActionScene.Swap &&
            action.sceneId === IdScene.PlayerBase;
        var openAfterTutorial = action.type === TypeActionTutorial.Complete;
        return spawnFirstDialog || openAfterTutorial;
    }), take(1), switchMap(function () { return of(actionModalOpen(IdModal.TerminationDialog)); }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/sunsetting/epicOpenTerminationDialog.ts
// module id = 2419
// module chunks = 3